export default __webpack_public_path__ + "static/media/clouddownload.108c6ab9.svg";